import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import PageShell, { PageHero } from "./PageShell";
import ProcessV2 from "../components/ProcessV2";
import ManifestoV2 from "../components/ManifestoV2";
import FAQV2 from "../components/FAQV2";
import { Arrow } from "../components/Primitives";
import { V2, pickLang } from "../copy";
import { route } from "../paths";

const HowItWorksPageV2: React.FC = () => {
  const { currentLanguage } = useLanguage();
  const lang = pickLang(currentLanguage);
  const isFr = lang === "fr";
  const steps = V2[lang].process.steps;

  return (
    <PageShell
      seo={{
        title: isFr
          ? "Comment ça marche : nettoyage de baskets en 4 étapes | Lave Tes Baskets"
          : "How it works: sneaker cleaning in 4 steps | Lave Tes Baskets",
        description: isFr
          ? "Composez votre prestation en ligne, déposez en point relais ou faites collecter, l'atelier nettoie, vous récupérez vos paires comme neuves. Notifié à chaque étape."
          : "Build your service online, drop off at a relay point or get picked up, the workshop cleans, you get your pairs back like new. Notified at every step.",
        canonicalPath: route(lang, "comment-ca-marche"),
        jsonLd: [
          {
            "@context": "https://schema.org",
            "@type": "HowTo",
            name: isFr
              ? "Comment faire nettoyer ses sneakers avec Lave Tes Baskets"
              : "How to get your sneakers cleaned with Lave Tes Baskets",
            step: steps.map((s, i) => ({
              "@type": "HowToStep",
              position: i + 1,
              name: s.title,
              text: s.desc,
            })),
          },
        ],
      }}
    >
      <PageHero
        crumbs={[
          { label: isFr ? "Accueil" : "Home", to: route(lang) },
          { label: isFr ? "Comment ça marche" : "How it works" },
        ]}
        index="03"
        eyebrow={isFr ? "Méthode" : "Method"}
        title={
          isFr ? (
            <>
              Quatre gestes, <em className="italic text-tangerine">une paire neuve.</em>
            </>
          ) : (
            <>
              Four moves, <em className="italic text-tangerine">one brand-new pair.</em>
            </>
          )
        }
        lede={
          isFr
            ? "Composez, déposez ou faites collecter, laissez l'atelier travailler, récupérez. Vous êtes notifié à chaque étape."
            : "Build, drop off or get picked up, let the workshop work, get them back. You're notified at every step."
        }
        actions={
          <>
            <Link to={`/${lang}/signup`} className="v2-btn v2-btn-solid">
              {isFr ? "Commencer" : "Get started"}
              <Arrow />
            </Link>
            <Link to={route(lang, "tarifs")} className="v2-btn v2-btn-ghost">
              {isFr ? "Voir les tarifs" : "See pricing"}
            </Link>
          </>
        }
        aside={
          <img src="/illustrations/landing/composer.webp" alt="" loading="lazy" className="ml-auto w-full max-w-[440px] object-contain" />
        }
      />
      <ProcessV2 hideHeader />
      <ManifestoV2 />
      <FAQV2 />
    </PageShell>
  );
};

export default HowItWorksPageV2;
